<template>
  <v-container
      :fluid="true"
      fill-height
  >
    <v-row>
      <v-col>
        <v-row v-if="$vuetify.display.mdAndUp">
          <v-col cols="3">
            <p class="text-subtitle-1 text-center">Username</p>
          </v-col>
          <v-divider :vertical="true"/>
          <v-col cols="4">
            <p class="text-subtitle-1 text-center">Name</p>
          </v-col>
          <v-divider :vertical="true"/>
          <v-col cols="5">
            <p class="text-subtitle-1 text-center">Balance</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p
            v-if="loading === false && items.length === 0"
            class="text-h6 text-center"
        >
          Clients not found
        </p>
        <v-list v-if="loading">
          <accountant-list-item-skeleton
              v-for="index in skeletonAmount"
              :key="index"
              :index="index"
          />
        </v-list>
        <v-list v-else>
            <accountant-list-item
                v-for="(item, index) in items" :key="item"
                :id="item.id"
                :username="item.username"
                :name="item.name"
                :balances="item.balances"
                :index="index"
            />
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import AccountantListItem from "@/components/Accountant/AccountantListItem.vue";
import AccountantListItemSkeleton from "@/components/Accountant/AccountantListItemSkeleton.vue";

export default {
  name: "AccountantList",
  components: {AccountantListItemSkeleton, AccountantListItem},
  props: {
    items: Array,
    skeletonAmount: Number,
    loading: Boolean
  }
}
</script>

<style scoped>

</style>